import { getFirstPropertyIndexOfActivePage } from "./getFirstPropertyIndexOfActivePage";
export var getFirstPropertyPositionOfActivePage = function getFirstPropertyPositionOfActivePage(activePage) {
  return getFirstPropertyIndexOfActivePage(activePage) + 1;
};